<template>
    <div v-if="requisicao">
        <detalhe titulo="Contrato" :size="size1" v-if="requisicao.contrato">{{
            requisicao.contrato.vcCodigoEstruturado
        }}</detalhe>
        <detalhe titulo="Fornecedor" :size="size1" v-if="requisicao.contrato">{{
            requisicao.contrato.fornecedor.nome
        }}</detalhe>
        <detalhe titulo="Processo" :size="size1">{{
            requisicao.processo
        }}</detalhe>
        <detalhe titulo="Necessário Envio" :size="size1"
            ><app-status
                :status="requisicao.naoAutorizacaoEnvio ? 'NÃO' : 'SIM'"
            ></app-status
        ></detalhe>
        <detalhe titulo="Data Requisição" :size="size1">{{
            $moment(requisicao.dataRequisicao).format('DD/MM/YYYY')
        }}</detalhe>
        <detalhe titulo="Data Necessidade" :size="size1">{{
            $moment(requisicao.dataNecessidade).format('DD/MM/YYYY')
        }}</detalhe>
        <detalhe titulo="Objeto" :size="size1">{{ requisicao.objeto }}</detalhe>
        <detalhe titulo="Informação complementar" :size="size1">{{
            requisicao.textoComplementar
        }}</detalhe>
        <detalhe titulo="Solicitante da Requisição" :size="size1"
            >{{ requisicao.solicitante
            }}<span v-if="requisicao.contatoSolicitante">
                -
                {{ requisicao.contatoSolicitante }}</span
            ></detalhe
        >
        <detalhe titulo="Valor" :size="size1">{{
            requisicao.valor | currency
        }}</detalhe>
        <detalhe titulo="Situação" :size="size1" v-if="requisicao.situacao"
            ><app-status :status="requisicao.situacao"></app-status
        ></detalhe>
        <detalhe
            titulo="Situação solicitação"
            :size="size1"
            v-if="requisicao.situacao"
            ><app-status
                :status="requisicao.situacaoSolicitacaoDescricao"
            ></app-status
        ></detalhe>
        <detalhe titulo="Responsável pela aprovação" :size="size1" v-if="nomeResponsavelAprovacaoValido">{{
            requisicao.responsavelAprovacao
        }}</detalhe>
        <detalhe titulo="Data aprovação solicitação" :size="size1" v-if="dataAprovacaoRequisicaoValida">{{
            requisicao.dataAprovacao
        }}</detalhe>
        <detalhe titulo="Responsável Requisição/Aprovação" :size="size1">{{
            `${requisicao.nomeAprovadorServico}`
        }}<br/>
        {{ `EMAIL: ${requisicao.emailAprovadorServico}` }}
        <br/>
        {{ `CONTATO: ${obterContatoAprovadorServico}` }}
        </detalhe>
         <detalhe titulo="Gestor da Solicitação" :size="size1" v-if="nomeGestorSolicitacaoValido && emailGestorSolicitacaoValido">
            {{ `${requisicao.nomeGestorSolicitacao}` }}
            <br/>
            {{ `EMAIL: ${requisicao.emailGestorSolicitacao}` }}
        </detalhe>
        <detalhe titulo="Responsável Devolução Atual" :size="size1">
            {{ `${requisicao.nomeResponsavelDevolucao || "Não devolvido"}` }}
            <br/>
            {{ `EMAIL: ${requisicao.emailResponsavelDevolucao || "Não devolvido"}` }}
        </detalhe>
        <detalhe
            titulo="Justificativa da Finalização"
            v-if="mostrarJustificativaFinalizacao"
            :size="size1"
            >{{ requisicao.justificativaFinalizacao }}</detalhe
        >
        <detalhe
            titulo="Motivo Cancelamento"
            v-if="requisicao.motivoCancelamento"
            :size="size1"
            >{{ requisicao.motivoCancelamento }}</detalhe
        >
        <detalhe
            titulo="Cancelada em"
            :size="size1"
            v-if="requisicao.dataCancelamento"
            >{{
                $moment(requisicao.dataCancelamento).format('DD/MM/YYYY')
            }}</detalhe
        >
        <detalhe
            titulo="Cancelada por"
            :size="size1"
            v-if="requisicao.usuarioCancelamento"
            >{{ requisicao.usuarioCancelamento }}</detalhe
        >
    </div>
</template>

<script>
import { situacaoRequisicao } from './SituacaoRequisicao'

export default {
    props: {
        requisicao: {
            type: Object
        }
    },

    data() {
        return {
            size1: '160'
        }
    },

    methods: {},

    computed: {
        mostrarJustificativaFinalizacao() {
            if (this.requisicao) {
                return (
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.FINALIZADA &&
                    this.requisicao.justificativaFinalizacao
                )
            } else {
                return false
            }
        },
        dataAprovacaoRequisicaoValida(){
            return this.requisicao && this.requisicao.dataAprovacao &&
                this.requisicao.dataAprovacao != 'NÃO CONSTA'
        },
        nomeResponsavelAprovacaoValido() {
            return this.requisicao && this.requisicao.responsavelAprovacao &&
                this.requisicao.responsavelAprovacao != 'NÃO CONSTA'
        },
        obterContatoAprovadorServico() {
            return this.requisicao && this.requisicao.contatoAprovadorServico
                ? this.requisicao.contatoAprovadorServico
                : 'Não informado'
        },
        nomeGestorSolicitacaoValido(){
            return this.requisicao && this.requisicao.nomeGestorSolicitacao;
        },
        emailGestorSolicitacaoValido() {
            return this.requisicao && this.requisicao.emailGestorSolicitacao;
        }
    },

    created() {},

    watch: {}
}
</script>
